"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UNKNOWN = exports.UNKNOWN = 0;
var REQUEST_TIMEOUT = exports.REQUEST_TIMEOUT = 408; // client took too long
var TOO_MANY_REQUESTS = exports.TOO_MANY_REQUESTS = 429;
var SERVICE_UNAVAILABLE = exports.SERVICE_UNAVAILABLE = 503;
var GATEWAY_TIMEOUT = exports.GATEWAY_TIMEOUT = 504;


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-query/dist/es/constants/status-codes.js
// module id = 611
// module chunks = 27